<template>
    <v-container :pa-0="value">
        <pr-loading v-model="loading" />
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-form ref="form">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-text-field v-model="data.partner.name" :label="$t('PartnerName')" required :rules="vRequired" @change="partnerChanged"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="data.name" :label="$t('ContactName')"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-suggest-settlement :label="$t('Settlement')" v-model="data.address" :rules="vRequireCode"></v-suggest-settlement>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="data.address.complex.name" :label="$t('Complex')" :rules="vAddressComplex"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="data.address.street.name" :label="$t('Street')" :rules="vAddressStreet"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2>
                  <v-text-field v-model="data.address.street_number" label="№" :rules="vAddressStreetNo"></v-text-field>
                </v-flex>
                <v-flex xs6 sm1>
                  <v-text-field v-model="data.address.block" :label="$t('block')" :rules="vAddressBlock"></v-text-field>
                </v-flex>
                <v-flex xs6 sm1>
                  <v-text-field v-model="data.address.entrance" :label="$t('entrance')"></v-text-field>
                </v-flex>
                <v-flex xs6 sm1>
                  <v-text-field v-model="data.address.floor" :label="$t('floor')"></v-text-field>
                </v-flex>
                <v-flex xs6 sm1>
                  <v-text-field v-model="data.address.apartment" :label="$t('apartment')"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="data.address.additional" :label="$t('Address additional')" :rules="vAddressOther"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field ref="phoneInput" v-model="data.phone" type="tel" :hint="$t('Phone international hint')" :label="$t('Phone')" :rules="vPhone"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="data.email" :label="$t('Email')" :rules="vEmail"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="data.instructions" :label="$t('Instructions')"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close" v-shortkey.once="['esc']"   @shortkey="close">{{ $t('Cancel') }}</v-btn>
            <v-btn color="blue darken-1" flat @click.native="save"  v-shortkey.once="['enter']" @shortkey="save" :loading="saving">{{ $t('Save') }}</v-btn>
          </v-card-actions>
        </v-card>

        <v-snackbar v-model="errorBar" value="true" right top multi-line color="error" :timeout="15000">
          {{ errorMsg }}
          <v-btn dark flat @click="errorBar = false">
            {{ $t('OK')}}
          </v-btn>
        </v-snackbar>

    </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { debounce } from "lodash";
import { contacts } from "../resources";
import { validateEmail, extractBodyErrorMessages } from "../components/util";
import VSuggestSettlement from "../components/VSuggestSettlement";
import PrLoading from "../components/Loading";

import { phoneRules, phoneCountry } from "../components/phone";

export default {
  name : "contact",

  components: {
    VSuggestSettlement,
    PrLoading
  },

  props : ["id", "value"],

  data() {
    return {
      errorBar : false,
      errorMsg : "",
      loading : false,
      saving : false,
      data : {
        partner : { code : null, name : ""},
        address : { settlement : { code : null, name : ""}, complex : { code : null, name : ""}, street : { code : null, name : ""}},
        name : "",
        phone : "",
        email : "",
        instructions : ""
      },
      defaultItem : {
        partner : { code : null, name : ""},
        address : { settlement : { code : null, name : ""}, complex : { code : null, name : ""}, street : { code : null, name : ""}},
        name : "",
        phone : "",
        email : "",
        instructions : ""
      },
      vRequired    : [(v) => !!v || this.$t("This field is required!")],
      vRequireCode : [(v) => (!!v && !!v.code) || this.$t("This field is required!")],
      vEmail : [(v) => !v || validateEmail(v) || this.$t("Invalid email address")],
      vAddressComplex : [(v) => this.validateAddress("complex") || this.$t("Address is required")],
      vAddressStreet  : [(v) => this.validateAddress("street") || this.$t("Address is required")],
      vAddressStreetNo: [(v) => this.validateAddress("streetNo") || this.$t("Address is required")],
      vAddressBlock   : [(v) => this.validateAddress("block") || this.$t("Address is required")],
      vAddressOther   : [(v) => this.validateAddress("other") || this.$t("Address is required")]
    };
  },

  computed : {
    vPhone() {
      return phoneRules(key => this.$t(key), { country: phoneCountry(this.data.address) });
    },
    ...mapGetters(["userInfo", "currentCompany"]),
    formTitle() {
      return this.id <= 0 ? this.$t("New contact") : this.$t("Edit contact");
    },
    fullAddressText() {
      return this.data.address.additional
      + this.data.address.settlement.name
      + this.data.address.complex.name
      + this.data.address.street.name
      + this.data.address.street_number
      + this.data.address.block;
    }
  },

  watch : {
    vPhone() {
      // Vuetify 1 compares rule functions as objects and can miss changed closures.
      this.$nextTick(() => {
        if (this.$refs.phoneInput) this.$refs.phoneInput.validate();
      });
    },

    fullAddressText : {
      handler(val) {
        this.validateForm();
      }
    },
    value : {
      handler(val) {
        this.data = val;
      }
    }
  },

  methods : {
    close(isSaved) {
      if (this.value) {
        this.$emit("close", isSaved === true ? this.data : false);
      }
      else
        this.$router.push({"name" : "contacts"});
    },

    save() {
      if (!this.$refs.form.validate()) {
        this.errorMsg = this.$t("Please fix errors before continuing!");
        this.errorBar = true;
        return;
      }

      // support for current company
      if (this.currentCompany && this.currentCompany.code && this.userInfo && this.userInfo.holding && this.userInfo.holding.length > 0)
      {
        this.data.owner = this.currentCompany;
      }

      let p = (this.id > 0)//
        ? contacts.save({ id: this.id }, this.data)
        : contacts.create({}, this.data);

      this.saving = true;
      p.then((r) => {
        if (r.body) {
          this.data = r.body;
        }
        this.close(true);
      }).catch((err) => {
        let msg = extractBodyErrorMessages(err.body);
        if (!!msg)
          this.errorMsg = msg;
        else
          this.errorMsg = this.$t("Error saving contact");
        this.errorBar = true;
        console.log("Error saving contact", err);
      }).finally(() => {
        this.saving = false;
      });
    },

    loadContact() {
        this.loading = true;
        if (this.id > 0) {
            contacts.load({ id : this.id }).then((result) => {
                if (result.status === 200 && result.body.id) {
                    this.data = result.body;
                } else {
                    this.data = this.defaultItem;
                }
            }).catch((err) => {
                console.log("Error loading contact " + this.id + " state = " + err.status);
                this.data = this.defaultItem;
            }).finally(() => {
                this.loading = false;
            });
        } else {
          // new contact
          if (this.value)
            this.data = this.value;
          setTimeout(() => (this.loading = false), 500);
        }
    },

    validateFormImpl() {
      this.$refs.form.validate();
    },

    validateAddress(source) {
      let a = this.data.address;
      if (source === "streetNo")
        return (
          !!a.additional ||
          !!a.street_number ||
          !!a.complex.name ||
          (!!a.street.name && !!a.block)
          );
      if (source === "block")
        return (
          !!a.additional ||
          !!a.block ||
          (!!a.street.name && !!a.street_number)
        );

      return !!a.additional || !!a.street.name || !!a.complex.name;
    },

    partnerChanged() {
      let t = this.data;
      if (t && t.partner && t.partner.code)
        t.partner.code = null;
    }
  },

  created () {
    this.validateForm = debounce(this.validateFormImpl, 500);
  },

  mounted() {
    this.loadContact();
    this.validateForm();
  }
}
</script>
